import styled from 'styled-components';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { Text } from '../CommonComponents/OPL/Text/Text';
import { IconButton } from '../CommonComponents/OPL/IconButton/IconButton';

export const Avatar = styled.div<{ url: string }>`
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin-right: 24px;
  background-image: ${({ url }) => `url(${url})`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  box-shadow: inset 0 2px 4px 0 hsla(0, 0%, 0%, 0.2);
  flex-shrink: 0;
`;

export const CopyButton = styled(IconButton)({
  opacity: 0,

  '&:focus': {
    opacity: 1,
  },
});

export const StyleListItem = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  padding: '6px 24px',
  gap: 16,

  '&:hover': {
    [CopyButton]: {
      opacity: 1,
    },
  },
});

export const AdditionalText = styled(Text)(({ theme }) => ({
  fontFamily: theme.fontFamily,
  padding: '8px 24px',

  'div, i, b, p, a': {
    fontFamily: theme.fontFamily,
  },

  'h1:first-child, h2:first-child, h3:first-child': {
    marginTop: 0,
  },

  h1: {
    fontSize: theme.fontSizes.h4,
    fontWeight: theme.fontWeights[500],
    lineHeight: theme.lineHeights.h4,
    marginBottom: 8,
  },

  h2: {
    fontSize: theme.fontSizes.h5,
    fontWeight: theme.fontWeights[500],
    lineHeight: theme.lineHeights.h5,
  },

  h3: {
    fontSize: theme.fontSizes.h6,
    fontWeight: theme.fontWeights[500],
    lineHeight: theme.lineHeights.h6,
  },

  p: {
    fontSize: theme.fontSizes.body,
    fontWeight: theme.fontWeights[400],
    lineHeight: theme.lineHeights.body,
  },

  a: {
    fontSize: theme.fontSizes.body,
    fontWeight: theme.fontWeights[400],
    color: theme.colors.primary['500'],
  },

  img: {
    maxWidth: '100%',
  },
}));
